var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-form',{attrs:{"label-position":_vm.labelPosition,"label-width":_vm.labelWidth,"size":"small"}},[(_vm.labelPosition === 'top')?_c('MultiItemList',{attrs:{"label":_vm.label,"data":_vm.value,"addText":"添加脚本","prop":{
        label: 'showName',
        value: 'eventType',
      }},on:{"add":function($event){return _vm.onEditEvent()},"edit":_vm.onEditEvent,"delete":_vm.onRemoveEvent}}):_c('el-form-item',{attrs:{"label":_vm.label}},[_c('MultiItemBox',{attrs:{"data":_vm.value,"addText":"添加脚本","prop":{
          label: 'showName',
          value: 'eventType',
        }},on:{"add":function($event){return _vm.onEditEvent()},"edit":_vm.onEditEvent,"delete":_vm.onRemoveEvent}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }